import { Checkbox, Col, Icon, Row } from 'antd';
import Router, { withRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import Heading from '@/src/shared/components/Heading';
import { space } from '@/styles';

import EditSavedSearch from './EditSavedSearch';
import style from './style';

const { m } = space;

const index = props => {
  const {
    data,
    closeSavedSearchesModal,
    saveCompliassistSearch,
    setSelectedSearch,
    setSearchAndFetchResults,
    setRefreshState,
  } = props;
  const [isModalVisible, setModalVisible] = useState(false);

  const dispatch = useDispatch();

  const updateURL = () => {
    const formattedURL = `/compliance/compliassist?searchId=${data.SearchId}`;
    Router.push(formattedURL, formattedURL, { shallow: true });
  };

  const titleClick = savedSearch => {
    closeSavedSearchesModal();
    dispatch(setSelectedSearch(savedSearch.SearchId));
    dispatch(
      setSearchAndFetchResults({ searchId: savedSearch.SearchId, personId: savedSearch.PersonId })
    );

    updateURL();
    // requestCharts(savedSearch);
  };

  const handleCheckboxChange = async () => {
    const newIncludeOnHomePage = data.IncludeOnHome === 'Y' ? 'N' : 'Y';
    const payload = {
      ...data,
      IncludeOnHome: newIncludeOnHomePage,
    };
    dispatch(saveCompliassistSearch({ payload }));
  };

  return (
    <Row gutter={16} type="flex" css={m.b16}>
      <EditSavedSearch
        visible={isModalVisible}
        closeModal={() => setModalVisible(false)}
        data={data}
        setRefreshState={setRefreshState}
      />
      <Col xs={14}>
        <Heading
          type={4}
          weight="bold"
          css={style.searchTitle}
          onClick={() => {
            titleClick(data);
          }}
        >
          {data.SearchDescription}
        </Heading>
      </Col>
      <Col xs={3}>
        <span css={[style.edit]} onClick={() => setModalVisible(true)}>
          <Icon type="edit" theme="filled" css={m.r8} />
          <span css={style.editText}>Edit</span>
        </span>
      </Col>
      <Col xs={3}>
        <Checkbox
          css={style.checkbox}
          checked={data.IncludeOnHome === 'Y'}
          onChange={handleCheckboxChange}
        />
      </Col>
    </Row>
  );
};

index.propTypes = {
  data: PropTypes.object.isRequired,
};

export default withRouter(index);
